module.exports = __webpack_public_path__ + "static/img/项目智能评审.610d152.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/operationDecision/项目智能评审.jpg
// module id = cdWH
// module chunks = 0